module.exports = __webpack_public_path__ + "img/24.b6b3433d.jpg";